export const userListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "کد نمایندگی",
    value: "refCode",
  },
  {
    title: "نقش",
    value: "faRole",
  },
];
export const courseSupportColums = [
  {
    title: "نوع پلتفرم",
    value: "platform",
  },
  {
    title: "لینک",
    value: "link",
  },
  {
    title: "اکانت",
    value: "account",
  },
];

export const sldierListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "بخش",
    value: "faPart",
  },
  {
    title: "موقعیت",
    value: "faPosition",
  },
];

export const vendorListColumns = [
  {
    title: "عکس",
    value: "showMainImage",
  },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "غرفه منتخب",
    value: "selectedBooth",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
];

export const walletsTransactionColumns = [
  { title: "منشأ تراکنش", value: "source" },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "مبلغ",
    value: "amount",
  },
  {
    title: "توضیحات",
    value: "description",
  },
  ,
  {
    title: "شماره تراکنش",
    value: "trackingCode",
  },
  {
    title: "نوع تراکنش",
    value: "type",
  },
  {
    title: "کمیسیونه ؟",
    value: "isCommission",
  },
  {
    title: "وضعیت",
    value: "faPaymentStatus",
  },
  {
    title: "تاریخ",
    value: "date",
  },
];
export const courseEnrollmentsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "نام دوره",
    value: "courseName",
  },
  {
    title: "مبلغ",
    value: "amount",
  },
  {
    title: "توضیحات",
    value: "description",
  },
  ,
  {
    title: "شماره تراکنش",
    value: "trackingCode",
  },
  {
    title: "وضعیت",
    value: "faPaymentStatus",
  },
  {
    title: "تاریخ",
    value: "date",
  },
];
export const affiliateEnrollmentsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "نام طرح",
    value: "level",
  },
  {
    title: "مبلغ",
    value: "amount",
  },
  ,
  {
    title: "شماره تراکنش",
    value: "trackingCode",
  },
  {
    title: "وضعیت",
    value: "faPaymentStatus",
  },
  {
    title: "تاریخ",
    value: "date",
  },
];
export const articleListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
];
export const notFoundCoursesUserListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
];

export const provinceListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "تعداد شهر",
    value: "cityNumber",
  },
];

export const citiesListColumns = [
  {
    title: "نام شهر",
    value: "name",
  },
];

export const learnListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
  {
    title: "توضیحات",
    value: "desscription",
  },
  {
    title: "لینک ویدئو",
    value: "link",
  },
];

export const couponListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "کد",
    value: "code",
  },
  {
    title: "نوع",
    value: "type",
  },
  {
    title: "مقدار",
    value: "value",
  },
  {
    title: "محدویت دارد؟",
    value: "isLimited",
  },
  {
    title: "تعداد استفاده",
    value: "usedCount",
  },
  {
    title: "تاریخ اعتبار",
    value: "expireDate",
  },
  {
    title: "کف قیمت",
    value: "minPrice",
  },
  {
    title: "سقف قیمت",
    value: "maxPrice",
  },
  {
    title: "کوئری ها",
    value: "query",
  },
];

export const questionsColumns = [
  {
    title: "عنوان",
    value: "title",
  },
  {
    title: "توضیحات",
    value: "description",
  },
];

export const learningOutcomesColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "توضیحات",
    value: "description",
  },
  {
    title: "آدرس ویدئو",
    value: "videoUrl",
  },
  {
    title: "آدرس صدا",
    value: "voiceUrl",
  },
];

export const categoryListColumns = [
  {
    title: "نام",
    value: "name",
  },
];

export const faqListColumns = [
  {
    title: "عنوان",
    value: "title",
  },
  {
    title: "بخش",
    value: "part",
  },
  {
    title: "اولویت",
    value: "priority",
  },
];

export const learnCategoryListColumns = [
  {
    title: "نام",
    value: "name",
  },
];

export const productOptionsColumns = [
  {
    title: "نام",
    value: "value",
  },
];

export const variationOptionsColumns = [
  {
    title: "مقدار",
    value: "value",
  },
  {
    title: "قیمت",
    value: "price",
  },
  {
    title: "عکس",
    value: "image",
  },
  {
    title: "توضیحات",
    value: "desc",
  },
  {
    title: "نوع تخفیف",
    value: "discountType",
  },
  {
    title: "موجودی انبار",
    value: "stock",
  },
  {
    title: "محدودیت",
    value: "limitStock",
  },
  {
    title: "تخفیف",
    value: "discount",
  },
  {
    title: "موجودی",
    value: "inventoryStatus",
  },
  {
    title: "شناسه یکتا",
    value: "sku",
  },
];

export const sectionsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "آدرس",
    value: "url",
  },
  {
    title: "قسمت",
    value: "part",
  },
  {
    title: "توضیحات",
    value: "description",
  },
  {
    title: "توضیحات کوتاه",
    value: "shortDescription",
  },
  {
    title: "رایگان",
    value: "isFree",
  },
];

export const featuresColumns = [
  {
    title: "عنوان",
    value: "title",
  },
  {
    title: "مقدار",
    value: "value",
  },
];

export const productListColumns = [
  {
    title: "عکس",
    value: "showMainImage",
  },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "قیمت پایه (تومان)",
    value: "basePrice",
  },
  {
    title: "تخفیف",
    value: "showDiscountPercent",
  },
  {
    title: "اتمام تخفیف",
    value: "discountExpireDate",
  },
  {
    title: "دسته بندی",
    value: "showCategories",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
  {
    title: "موجودی",
    value: "faInventoryStatus",
  },
  {
    title: "موجودی انبار",
    value: "stock",
  },
];
export const productStocksListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "وضعیت نمایش در سایت",
    value: "status",
  },
  {
    title: "وضعیت موجود بودن در سایت",
    value: "inventoryStatus",
  },
  {
    title: "موجودی",
    value: "stock",
  },
  {
    title: "قیمت خرید (تومان)",
    value: "buyPriceDisplay",
  },
  {
    title: "قیمت فروش (تومان)",
    value: "basePriceDisplay",
  },
  {
    title: "شناسه",
    value: "sku",
  },
];
export const updateProductStockListColumns = [
  {
    title: "عکس",
    value: "showMainImage",
  },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "قیمت پایه (تومان)",
    value: "basePrice",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
  {
    title: "موجودی",
    value: "faInventoryStatus",
  },
  {
    title: "موجودی انبار",
    value: "stock",
  },
];

export const UpdateProductsStockLogsColumns = [
  {
    title: "نام محصول",
    value: "name",
  },
  {
    title: "شماره ویژگی",
    value: "varNumber",
  },
  {
    title: "مقدار قبلی",
    value: "preStock",
  },
  {
    title: "مقدار جدید",
    value: "stock",
  },
  {
    title: "تفاضل",
    value: "difference",
  },
  {
    title: "تاریخ",
    value: "createdAt",
  },
  {
    title: "کاربر",
    value: "userName",
  },
];

export const vendorProductListColumns = [
  {
    title: "عکس",
    value: "showMainImage",
  },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "قیمت پایه (تومان)",
    value: "basePrice",
  },
  {
    title: "تخفیف",
    value: "showDiscountPercent",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
];

export const courseListColumns = [
  {
    title: "عکس",
    value: "showImage",
  },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "قیمت (تومان)",
    value: "price",
  },
  {
    title: "تخفیف",
    value: "showDiscountPercent",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
];

export const barcodesListColumns = [
  {
    title: "شماره سفارش",
    value: "trackingCode",
  },
  {
    title: "بارکد",
    value: "barcode",
  },
];
export const notFoundBarcodesListColumns = [
  {
    title: "شماره سفارش",
    value: "trackingCode",
  },
];

export const shippingListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "قیمت",
    value: "faPrice",
  },
  {
    title: "پیش فرض",
    value: "faIsDefault",
  },
  {
    title: "رایگان برای همه",
    value: "faFreeForAll",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
];
export const usersReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "نقش",
    value: "role",
  },
  {
    title: "مجموع تعداد سفارش",
    value: "ordersTotalCount",
  },
  {
    title: "مجموع خالص",
    value: "_ref_user_finalProductsPrice",
  },
  {
    title: "مجموع نا خالص",
    value: "_ref_user_totalProductsPrice",
  },
];
export const customerSalesReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "مجموع تعداد سفارش",
    value: "ordersTotalCount",
  },
  {
    title: "مجموع خالص",
    value: "finalPriceWithoutShippingSum",
  },
  {
    title: "مجموع نا خالص",
    value: "totalProductsPriceSum",
  },
];
export const provinceSalesReportsColumns = [
  {
    title: "نام",
    value: "province",
  },
  {
    title: "مجموع تعداد سفارش",
    value: "ordersTotalCount",
  },
  {
    title: "مجموع خالص",
    value: "finalPriceWithoutShippingSum",
  },
  {
    title: "مجموع نا خالص",
    value: "totalProductsPriceSum",
  },
];
export const usersCourseEnrollmentsReportColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "تعداد",
    value: "courseCount",
  },
];
export const courseEnrollmentsReportColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "نام دوره",
    value: "courseName",
  },
  {
    title: "وضعیت پرداخت",
    value: "paymentStatus",
  },
  {
    title: "تاریخ",
    value: "createdAt",
  },
];
export const productsReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "قیمت فروش",
    value: "basePrice",
  },
  {
    title: "قیمت خرید",
    value: "buyPrice",
  },
  {
    title: "مجموع قیمت",
    value: "totalPrice",
  },
  {
    title: "تعداد",
    value: "total",
  },
  {
    title: "شناسه",
    value: "productSku",
  },
  {
    title: "تاریخ ایجاد",
    value: "createdAt",
  },
];
